<template>
    <div class="routing-addresses-empty">
        <CompassEmptyState
            illustrationPath="/ressources/logged/img/illustrations/pdp/warning-company-directory-white.svg"
            :title="translations.title"
            :caption="translations.caption"
        >
            <CompassButton
                :label="translations.action"
                :type="CompassEnums.ButtonType.TERTIARY"
                @click="onLearnMore"
            />
        </CompassEmptyState>
    </div>
</template>

<script setup lang="ts">
import { inject } from 'vue';
import type { Translator } from 'types/injects/translator.type';
// TODO(SAAS-32515): replace with the real FAQ URL once available.
const FAQ_URL = 'https://help.sellsy.com/fr/';

const $t = inject('$t') as Translator;

const translations: Record<string, string> = {
    title: $t.__('overview.tabs.TabRoutingAddresses.empty_state.not_detected.title'),
    caption: $t.__('overview.tabs.TabRoutingAddresses.empty_state.not_detected.subtitle'),
    action: $t.__('overview.tabs.TabRoutingAddresses.empty_state.not_detected.action'),
};

const onLearnMore = (): void => {
    window.open(FAQ_URL, '_blank', 'noopener,noreferrer');
};
</script>

<style lang="scss" scoped>
.routing-addresses-empty {
    margin-top: var(--spacing-4);
}
</style>
